import React from 'react';
import { Link } from 'react-router-dom';
import NewLayout from '../layout/dashboard/NewLayout';
import '../styles/no-route.css';

const AccessDenied = () => {
  return (
    <NewLayout>
      <div className="content-center">
        <div>
          <h2>You do not have access to this page.</h2>
          <p>
            If you believe this is an error, please reach out to the project
            administrator for assistance.
          </p>
          <Link to="/dashboard">Back to dashboard</Link>
        </div>
      </div>
    </NewLayout>
  );
};

export default AccessDenied;
